import styled, { type StyledComponent } from '@emotion/styled'
import { Link, type LinkProps } from 'react-router'
import { hexColors } from '@mobi/settings'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { font, spacing } from '@mobi/component-library/Foundations'

export const AccountDetailsSectionStyled = styled.div({
  paddingTop: '2rem',
})

export const LoginSignUpSectionStyled = styled.div({
  paddingTop: '2.5rem',
  display: 'flex',
  '*:not(:last-child)': {
    marginRight: '1.5rem',
  },
})

export const DepositWithdrawSectionStyled = styled.div({
  display: 'flex',
  '*:not(:last-child)': {
    marginRight: '1.5rem',
  },
})

export const AccountNameLabelStyled = styled.div({
  color: hexColors.studio,
  fontWeight: '700',
  fontSize: '2rem',
  fontFamily: font.family.secondary,
})

export const AccountNumberLabelStyled = styled.div({
  color: hexColors.nero,
  fontWeight: '300',
  fontSize: '1.2rem',
  fontFamily: font.family.secondary,
})

export const ExternalLinkStyled = styled.a({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx2,
  color: hexColors.blueDiamond,
  fontSize: '1.4rem',
  fontFamily: font.family.secondary,
  textDecoration: 'none',
  padding: '0.5em 0',

  em: {
    fontFamily: font.family.primary,
    fontSize: font.size.xs.fontSize,
    fontWeight: font.weight.bold,
    padding: '0.1rem 0.5rem',
    transform: 'translateY(-0.2rem)',
    fontStyle: 'italic',
    lineHeight: 1,
    textTransform: 'uppercase',
    borderRadius: '1rem',
    color: hexColors.white,
    background: hexColors.freeSpeechRed,
  },
})

export const LinkStyled: StyledComponent<LinkProps> =
  styled(ExternalLinkStyled)().withComponent(Link)

export const HamburgerMenuSectionHeaderStyled = styled.h4({
  color: hexColors.grey,
  fontSize: '1.4rem',
  fontFamily: font.family.secondary,
  fontWeight: '500',
  textTransform: 'uppercase',
  textAlign: 'start',
  margin: '0.5rem 0',
})

export const SeparatorStyled = styled.hr({
  margin: '1rem 0',
  border: 0,
  height: 0,
  borderBottom: '1px solid ' + hexColors.grey3,
})

export const ExternalLinkIconStyled = styled(Icon)({
  verticalAlign: 'text-top',
  marginLeft: '0.5em',
  color: hexColors.deepLilac,
})

export const CloseButtonStyled = styled.span({
  padding: '1rem',
  position: 'absolute',
  top: 0,
  right: 0,
  cursor: 'pointer',
})

export const JustifiedLinkText = styled.span({
  display: 'inline-flex',
  justifyContent: 'space-between',
  width: '100%',
})
